import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { DevOnlyGate } from './app/DevOnlyGate';
import { queryClient } from './lib/query-client';
import './i18n/config';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <DevOnlyGate>
          <App />
        </DevOnlyGate>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
